/* Baas in Beeld — homepage scene. Vereist THREE (r128) en de markup uit sections/bib-scene.liquid */
(function () {
  function num(v, def) { var n = parseFloat(v); return isNaN(n) ? def : n; }
  function clamp(v, a, b) { return Math.min(Math.max(v, a), b); }
  function pad(n, l) { n = String(n); while (n.length < l) n = '0' + n; return n; }

  function cleanup() {
    if (window.__bsCleanup) { var fn = window.__bsCleanup; window.__bsCleanup = null; fn(); }
  }

  function boot() {
    cleanup();
    var rootEl = document.querySelector('[data-bs-root]');
    if (!rootEl) return;

    var ac = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    function on(target, type, fn, opts) {
      opts = opts || {};
      if (ac) opts.signal = ac.signal;
      target.addEventListener(type, fn, opts);
    }

    /* ---------- Instellingen uit de editor ---------- */
    var d = rootEl.dataset;
    var cfg = {
      particles: num(d.particles, 2000),
      glow: num(d.glow, 100) / 100,
      ribbon: num(d.ribbon, 100) / 100,
      speed: num(d.speed, 100) / 100,
      shape: d.shape || 'normal',
      accent: d.accent || '#D9FF43',
      parallax: d.parallax !== 'false',
      rings: d.rings !== 'false',
      hideHeader: d.hideHeader !== 'false'
    };
    var shapeAmp = cfg.shape === 'calm' ? 0.6 : (cfg.shape === 'wild' ? 1.5 : 1);

    var root = document.documentElement;
    root.classList.add('bs-on', 'bs-js');
    root.classList.toggle('bs-hideheader', cfg.hideHeader);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = window.matchMedia('(pointer: coarse)').matches;

    /* Vaste elementen naar <body>, zodat ze los van thema-containers meescrollen */
    var canvas = rootEl.querySelector('[data-bs-canvas]');
    var fixedEls = [canvas, rootEl.querySelector('.bs-grain'), rootEl.querySelector('.bs-nav'), rootEl.querySelector('.bs-hud')].filter(Boolean);
    fixedEls.forEach(function (el) { document.body.appendChild(el); });
    var tcEl = document.querySelector('[data-bs-tc]');
    var secEl = document.querySelector('[data-bs-sec]');
    var pctEl = document.querySelector('[data-bs-pct]');

    var panels = Array.prototype.slice.call(rootEl.querySelectorAll('.bs-panel'));
    var svcs = Array.prototype.slice.call(rootEl.querySelectorAll('.bs-svc'));
    var FPS = 25, REEL_SECONDS = 90;   // 25 fps (PAL), showreel van 90 seconden
    var lastTc = '', lastSec = '', lastPct = '', lastActive = -1;
    var tops = [];
    var visible = true;
    var raf = 0, io = null, ro = null, renderer = null, rt = 0;

    function rootMetrics() {
      var r = rootEl.getBoundingClientRect();
      return { top: r.top + window.scrollY, height: r.height };
    }
    function measure() {
      tops = panels.map(function (p) {
        var r = p.getBoundingClientRect();
        return r.top + window.scrollY + r.height / 2;
      });
    }
    /* Voortgang binnen de scene-sectie (niet de hele pagina, zodat de footer er niet in meetelt) */
    function scrollProgress() {
      var m = rootMetrics();
      var max = m.height - window.innerHeight;
      return max > 0 ? clamp((window.scrollY - m.top) / max, 0, 1) : 0;
    }
    function updateHud(p) {
      if (tcEl) {
        var total = Math.round(p * FPS * REEL_SECONDS);
        var ff = total % FPS, ss = Math.floor(total / FPS) % 60, mm = Math.floor(total / FPS / 60) % 60;
        var tc = '00:' + pad(mm, 2) + ':' + pad(ss, 2) + ':' + pad(ff, 2);
        if (tc !== lastTc) { tcEl.textContent = tc; lastTc = tc; }
      }
      if (pctEl) {
        var pc = pad(Math.round(p * 100), 3);
        if (pc !== lastPct) { pctEl.textContent = pc; lastPct = pc; }
      }
      var mid = window.scrollY + window.innerHeight / 2, best = 0, bd = 1e9;
      for (var i = 0; i < tops.length; i++) {
        var dd = Math.abs(tops[i] - mid);
        if (dd < bd) { bd = dd; best = i; }
      }
      if (best !== lastActive && panels[best]) {
        lastActive = best;
        var label = panels[best].getAttribute('data-label') || '';
        if (secEl && label !== lastSec) { secEl.textContent = label; lastSec = label; }
        svcs.forEach(function (s) { s.classList.toggle('bs-active', s === panels[best]); });
      }
    }
    measure();
    updateHud(scrollProgress());
    on(window, 'scroll', function () { updateHud(scrollProgress()); }, { passive: true });
    on(window, 'load', function () { measure(); updateHud(scrollProgress()); });

    /* Verberg de vaste lagen zodra de scene uit beeld is (bijv. bij de footer) */
    function setVisible(v) {
      visible = v;
      fixedEls.forEach(function (el) { el.classList.toggle('bs-hidden', !v); });
    }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) { setVisible(entries[0].isIntersecting); });
      io.observe(rootEl);
    }

    /* ---------- WebGL ---------- */
    if (window.THREE) {
      try {
        renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: !touch, powerPreference: 'high-performance' });
      } catch (e) { renderer = null; }
    }
    if (!renderer) {
      root.classList.add('bs-nogl');
    } else {
      startScene();
    }

    function startScene() {
      root.classList.remove('bs-nogl');
      var pr = Math.min(window.devicePixelRatio || 1, touch ? 1.5 : 2);
      renderer.setPixelRatio(pr);
      renderer.setClearColor(0x0a0a0a, 1);
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(58, 1, 0.1, 120);
      var LIME = new THREE.Color(cfg.accent), WARM = new THREE.Color(0xF5F3EF), GREY = new THREE.Color(0xA3A3A3);

      function makeCurve(phase, amp) {
        var pts = [], N = 18;
        for (var i = 0; i <= N; i++) {
          var t = i / N;
          pts.push(new THREE.Vector3(
            Math.sin(t * Math.PI * 5 + phase) * 3.4 * amp * shapeAmp,
            Math.cos(t * Math.PI * 3.3 + phase) * 1.7 * amp * shapeAmp,
            -t * 78));
        }
        return new THREE.CatmullRomCurve3(pts);
      }
      var path = makeCurve(0, 1), strandB = makeCurve(1.1, 1.15), strandC = makeCurve(2.3, 0.8);

      var timeUniforms = [];
      var ribbonVert = [
        'varying vec3 vN; varying vec3 vV; varying vec2 vUv; varying float vD;',
        'void main(){ vUv = uv; vec4 mv = modelViewMatrix * vec4(position, 1.0);',
        'vN = normalize(normalMatrix * normal); vV = -mv.xyz; vD = length(mv.xyz);',
        'gl_Position = projectionMatrix * mv; }'
      ].join('\n');
      var ribbonFrag = [
        'uniform float uTime; uniform vec3 uColor; uniform float uBase; uniform float uPhase; uniform float uFreq; uniform float uGain;',
        'varying vec3 vN; varying vec3 vV; varying vec2 vUv; varying float vD;',
        'void main(){',
        '  float rim = pow(1.0 - abs(dot(normalize(vN), normalize(vV))), 1.6);',
        '  float pulse = pow(sin(vUv.x * uFreq - uTime * 1.1 + uPhase) * 0.5 + 0.5, 7.0);',
        '  float fade = exp(-vD * 0.085) * smoothstep(0.3, 2.0, vD);',
        '  float a = (uBase + rim * 0.55 + pulse * 0.95) * fade * uGain;',
        '  gl_FragColor = vec4(uColor * a, a);',
        '}'
      ].join('\n');
      function ribbonMat(color, base, phase, freq) {
        var u = { uTime: { value: 0 }, uColor: { value: color }, uBase: { value: base }, uPhase: { value: phase }, uFreq: { value: freq }, uGain: { value: cfg.ribbon } };
        timeUniforms.push(u.uTime);
        return new THREE.ShaderMaterial({
          uniforms: u, vertexShader: ribbonVert, fragmentShader: ribbonFrag,
          transparent: true, depthWrite: false, blending: THREE.AdditiveBlending
        });
      }
      var segs = touch ? 500 : 900;
      scene.add(new THREE.Mesh(new THREE.TubeGeometry(path, segs, 0.03, 8, false), ribbonMat(LIME, 0.32, 0, 60)));
      scene.add(new THREE.Mesh(new THREE.TubeGeometry(strandB, segs, 0.016, 6, false), ribbonMat(WARM, 0.2, 2.0, 44)));
      scene.add(new THREE.Mesh(new THREE.TubeGeometry(strandC, segs, 0.012, 6, false), ribbonMat(GREY, 0.14, 4.0, 36)));

      /* Lensringen: één per [data-bs-ring]-blok */
      var ringEls = cfg.rings ? Array.prototype.slice.call(rootEl.querySelectorAll('[data-bs-ring]')) : [];
      /* Cameralens: rustige behuizing met streepjes en gegraveerde cijfers,
         glazen lensringen, gekleurde coating-reflecties en een lichtpuntje in het midden */
      var lensVert = [
        'varying vec2 vUv; varying float vD;',
        'void main(){ vUv = uv; vec4 mv = modelViewMatrix * vec4(position, 1.0);',
        'vD = length(mv.xyz); gl_Position = projectionMatrix * mv; }'
      ].join('\n');
      var lensFrag = [
        'uniform float uTime; uniform float uSeed; uniform float uGain; uniform vec3 uColor; uniform vec3 uWarm; uniform sampler2D uText;',
        'varying vec2 vUv; varying float vD;',
        'float band(float r, float c, float w){ float x = (r - c) / (w * 1.5); return exp(-x * x) * 0.85; }',
        'void main(){',
        '  vec2 p = (vUv - 0.5) * 2.0; float r = length(p);',
        '  float ang = atan(p.y, p.x);',
        '  vec3 BLUE = vec3(0.58, 0.64, 0.72);',
        '  float edge = 1.0 - smoothstep(0.56, 1.02, r);',
        '  float sweep = pow(max(cos(ang - uTime * 0.2 - uSeed * 2.1), 0.0), 6.0);',
        '  vec3 col = vec3(0.0);',
        '  col += mix(uWarm, BLUE, 0.35) * band(r, 0.96, 0.05) * (0.16 + 0.35 * sweep);',
        '  col += uColor * band(r, 0.87, 0.038) * (0.10 + 0.3 * sweep);',
        '  col += BLUE * band(r, 0.925, 0.07) * 0.03;',
        '  col += uWarm * band(r, 0.79, 0.024) * 0.08;',
        '  col += uColor * band(r, 0.715, 0.03) * 0.18 * (0.5 + 0.7 * sweep);',
        '  float wob = sin(uTime * 0.15 + uSeed * 2.0) * 0.10;',
        '  float cw = cos(wob), sw = sin(wob);',
        '  vec2 tp = vec2(cw * p.x + sw * p.y, -sw * p.x + cw * p.y);',
        '  vec2 tuv = tp * 0.5 + 0.5;',
        '  vec4 tx = (texture2D(uText, tuv, 0.8) + texture2D(uText, tuv, 1.6)) * 0.5;',
        '  col += tx.rgb * tx.a * 1.25;',
        '  float glass = smoothstep(0.26, 0.34, r) * (1.0 - smoothstep(0.66, 0.72, r));',
        '  float refA = pow(max(cos(ang - uTime * 0.16 - uSeed * 2.0 - 0.6), 0.0), 3.0);',
        '  float refB = pow(max(cos(ang - uTime * 0.16 - uSeed * 2.0 + 2.5), 0.0), 3.0);',
        '  col += uColor * refA * glass * (0.24 + 0.40 * band(r, 0.52, 0.16));',
        '  col += BLUE * refB * glass * (0.20 + 0.40 * band(r, 0.46, 0.15));',
        '  col += mix(uColor, BLUE, 0.5) * band(r, 0.60, 0.007) * 0.20;',
        '  col += uWarm * band(r, 0.46, 0.006) * 0.14;',
        '  col += BLUE * band(r, 0.30, 0.007) * 0.22;',
        '  col += uColor * band(r, 0.075, 0.006) * 0.26;',
        '  float sd = length(p - vec2(0.03, 0.04));',
        '  col += uWarm * exp(-sd * sd * 550.0) * 0.7;',
        '  col += BLUE * exp(-r * r * 40.0) * 0.14;',
        '  float breathe = 0.9 + 0.1 * sin(uTime * 0.8 + uSeed * 3.0);',
        '  float fade = exp(-vD * 0.06) * smoothstep(0.5, 3.0, vD);',
        '  float body = mix(0.40, 0.62, smoothstep(0.62, 0.84, r)) * (1.0 - 0.35 * exp(-r * r * 120.0));',
        '  float k = fade * edge * uGain;',
        '  gl_FragColor = vec4(col * k * breathe, body * fade * edge * clamp(uGain, 0.0, 1.0));',
        '}'
      ].join('\n');
      /* Graveerwerk van de lens: cijfers en tekst op bogen, getekend in een canvas */
      function makeLensText(accent) {
        var S = 1024, cv = document.createElement('canvas'); cv.width = cv.height = S;
        var cx = cv.getContext('2d'), R0 = S / 2;
        var font = "'Archivo', 'Arial Narrow', Arial, sans-serif";
        var BLUE = 'rgba(148,163,184,1)', ICE = 'rgba(205,212,222,1)';
        function arc(text, deg, rFrac, px, color, gap) {
          cx.font = '500 ' + px + 'px ' + font; cx.fillStyle = color; cx.textAlign = 'center'; cx.textBaseline = 'alphabetic';
          var R = R0 * rFrac, widths = [], total = 0, i;
          for (i = 0; i < text.length; i++) { var w = cx.measureText(text.charAt(i)).width + gap; widths.push(w); total += w; }
          var a = deg * Math.PI / 180 - (total / R) / 2;
          for (i = 0; i < text.length; i++) {
            var step = widths[i] / R, ang = a + step / 2;
            cx.save(); cx.translate(R0, R0); cx.rotate(ang); cx.translate(0, -R); cx.fillText(text.charAt(i), 0, 0); cx.restore();
            a += step;
          }
        }
        function draw() {
          cx.clearRect(0, 0, S, S);
          arc('2000', -40, 0.80, 28, BLUE, 8);
          arc('12000 · 10000 · 400 · 14 AN', 22, 0.80, 28, BLUE, 7);
          arc('12205h  1.207', -6, 0.745, 25, ICE, 6);
          arc('24 160h', 46, 0.745, 25, BLUE, 6);
          arc('1.00N', -66, 0.67, 24, BLUE, 6);
          arc('f/2.8', 68, 0.67, 24, ICE, 6);
        }
        draw();
        var tex = new THREE.CanvasTexture(cv);
        tex.anisotropy = 4;
        return { tex: tex, redraw: function () { draw(); tex.needsUpdate = true; } };
      }
      var lensText = makeLensText(cfg.accent);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { lensText.redraw(); });
      var lensGeo = new THREE.PlaneGeometry(4.6, 4.6);
      var rings = ringEls.map(function (el, idx) {
        var u = {
          uTime: { value: 0 }, uSeed: { value: idx * 1.7 }, uGain: { value: cfg.glow },
          uColor: { value: LIME }, uWarm: { value: WARM }, uText: { value: lensText.tex }
        };
        timeUniforms.push(u.uTime);
        var g = new THREE.Mesh(lensGeo, new THREE.ShaderMaterial({
          uniforms: u, vertexShader: lensVert, fragmentShader: lensFrag,
          transparent: true, premultipliedAlpha: true, depthWrite: false, side: THREE.DoubleSide
        }));
        g.renderOrder = 2;
        scene.add(g);
        return g;
      });
      function mapS(p) { return 0.03 + p * 0.94; }
      function placeRings() {
        if (!rings.length) return;
        var m = rootMetrics();
        var max = Math.max(m.height - window.innerHeight, 1);
        /* Op smalle schermen staat de tekst onderaan en vult de lens de hele breedte:
           lens kleiner en iets omhoog, zodat de cijfers niet over de tekst liggen */
        var narrow = window.innerWidth <= 760;
        var lensScale = narrow ? 0.66 : 0.86;
        var lensLift = narrow ? 1.0 : 0;
        ringEls.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          var center = r.top + window.scrollY + r.height / 2;
          var p = clamp((center - window.innerHeight / 2 - m.top) / max, 0, 1);
          var s = clamp(mapS(p) + 0.035, 0, 1);
          var pos = path.getPointAt(s), tan = path.getTangentAt(s);
          rings[i].position.copy(pos);
          rings[i].position.y += lensLift;
          rings[i].scale.setScalar(lensScale);
          rings[i].lookAt(rings[i].position.clone().sub(tan));   /* voorkant naar de camera, zodat de cijfers niet gespiegeld staan */
        });
      }

      /* Stof */
      var COUNT = Math.round(cfg.particles * (touch ? 0.45 : 1));
      var pos = new Float32Array(COUNT * 3), col = new Float32Array(COUNT * 3), size = new Float32Array(COUNT), ph = new Float32Array(COUNT);
      for (var i = 0; i < COUNT; i++) {
        var base = path.getPointAt(Math.random());
        var rr = 0.7 + Math.pow(Math.random(), 0.7) * 5.5, th = Math.random() * Math.PI * 2, ph2 = Math.acos(2 * Math.random() - 1);
        pos[i * 3] = base.x + rr * Math.sin(ph2) * Math.cos(th);
        pos[i * 3 + 1] = base.y + rr * Math.sin(ph2) * Math.sin(th) * 0.7;
        pos[i * 3 + 2] = base.z + rr * Math.cos(ph2) * 1.6;
        var roll = Math.random(), c = roll < 0.07 ? LIME : (roll < 0.6 ? WARM : GREY);
        var k = 0.55 + Math.random() * 0.45;
        col[i * 3] = c.r * k; col[i * 3 + 1] = c.g * k; col[i * 3 + 2] = c.b * k;
        size[i] = 0.5 + Math.pow(Math.random(), 3) * 2.2;
        ph[i] = Math.random();
      }
      var dustGeo = new THREE.BufferGeometry();
      dustGeo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
      dustGeo.setAttribute('aCol', new THREE.BufferAttribute(col, 3));
      dustGeo.setAttribute('aSize', new THREE.BufferAttribute(size, 1));
      dustGeo.setAttribute('aPhase', new THREE.BufferAttribute(ph, 1));
      var dustU = { uTime: { value: 0 }, uPx: { value: pr } };
      timeUniforms.push(dustU.uTime);
      scene.add(new THREE.Points(dustGeo, new THREE.ShaderMaterial({
        uniforms: dustU, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending,
        vertexShader: [
          'attribute float aSize; attribute float aPhase; attribute vec3 aCol;',
          'uniform float uTime; uniform float uPx; varying vec3 vC; varying float vA;',
          'void main(){ vec3 p = position;',
          '  p.x += sin(uTime * 0.25 + aPhase * 6.28) * 0.25; p.y += cos(uTime * 0.21 + aPhase * 9.0) * 0.25;',
          '  vec4 mv = modelViewMatrix * vec4(p, 1.0); float d = -mv.z;',
          '  gl_PointSize = min(aSize * uPx * (38.0 / max(d, 0.5)), 46.0);',
          '  float tw = 0.65 + 0.35 * sin(uTime * 1.3 + aPhase * 40.0);',
          '  vA = smoothstep(0.6, 3.0, d) * exp(-d * 0.05) * tw; vC = aCol;',
          '  gl_Position = projectionMatrix * mv; }'
        ].join('\n'),
        fragmentShader: [
          'varying vec3 vC; varying float vA;',
          'void main(){ float d = length(gl_PointCoord - 0.5); float a = smoothstep(0.5, 0.0, d); a *= a;',
          '  gl_FragColor = vec4(vC * a * vA, a * vA); }'
        ].join('\n')
      })));

      function resize() {
        var w = window.innerWidth, h = window.innerHeight;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        camera.fov = w / h < 1 ? 72 : 58;
        camera.updateProjectionMatrix();
        measure();
        placeRings();
      }
      on(window, 'resize', resize);
      on(window, 'load', function () { measure(); placeRings(); });
      resize();
      /* Afbeeldingen/video's kunnen de hoogte later nog veranderen */
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(function () { measure(); placeRings(); }, 120); });
        ro.observe(rootEl);
      }

      var mx = 0, my = 0, smx = 0, smy = 0;
      if (cfg.parallax) {
        on(window, 'pointermove', function (e) {
          mx = (e.clientX / window.innerWidth) * 2 - 1;
          my = (e.clientY / window.innerHeight) * 2 - 1;
        }, { passive: true });
      }

      var sp2 = scrollProgress(), tAcc = 0, last = performance.now();
      function frame(now) {
        raf = requestAnimationFrame(frame);
        var dt = Math.min((now - last) / 1000, 0.05); last = now;
        if (!visible) return;
        var p = scrollProgress();
        sp2 = reduce ? p : sp2 + (p - sp2) * (1 - Math.exp(-dt * 4.5 * cfg.speed));
        if (!reduce) tAcc += dt * cfg.speed;
        for (var i = 0; i < timeUniforms.length; i++) timeUniforms[i].value = tAcc;
        smx += (mx - smx) * 0.05; smy += (my - smy) * 0.05;

        var s = mapS(sp2);
        var cp = path.getPointAt(clamp(s - 0.03, 0, 1));
        var lp = path.getPointAt(clamp(s + 0.05, 0, 1));
        var tan = path.getTangentAt(clamp(s, 0, 1));
        camera.position.set(cp.x + smx * 0.5, cp.y + 0.3 - smy * 0.3, cp.z);
        camera.lookAt(lp);
        camera.rotateZ(-tan.x * 0.25);

        renderer.render(scene, camera);
      }
      raf = requestAnimationFrame(frame);
    }

    /* Opruimen (bij opnieuw laden van de sectie in de thema-editor) */
    window.__bsCleanup = function () {
      if (ac) ac.abort();
      cancelAnimationFrame(raf);
      clearTimeout(rt);
      if (io) io.disconnect();
      if (ro) ro.disconnect();
      if (renderer) {
        try { renderer.dispose(); if (renderer.forceContextLoss) renderer.forceContextLoss(); } catch (e) {}
      }
      fixedEls.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
      root.classList.remove('bs-on', 'bs-js', 'bs-nogl', 'bs-hideheader');
    };
  }

  /* Scripts met defer draaien in volgorde: THREE (r128) staat vóór dit bestand */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Thema-editor: sectie opnieuw opbouwen na elke wijziging */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bs-root]')) boot();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bs-root]')) cleanup();
  });
})();
